/**
 * Tour steps for the AI Insights page.
 */
const insightsSteps = [
  {
    target: '[data-tour="insights-panel"]',
    title: 'AI-powered insights ✨',
    content:
      'Summaries from your lab results appear here — highlighting trends, alerts, and recommendations. Always confirm with your doctor.',
    placement: 'bottom',
    route: '/insights',
    tourName: 'insights',
  },
  {
    target: '[data-tour="insights-panel"]',
    title: 'You\'re all set! 💚',
    content:
      'Explore freely, upload more reports, or check back anytime — we\'ll keep your health story up to date. Enjoy MediTrack!',
    placement: 'center',
    route: '/insights',
    tourName: 'insights',
    isLastStep: true,
  },
];

export default insightsSteps;
